/**
 * Open/close height transitions for R3NU product accordions (<details>).
 * Native <details> does not animate on close; we intercept summary clicks when motion is allowed.
 */
(function () {
  const DURATION_MS = 400;

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function resetArticleCircuitAccordions(container) {
    const root = container && container.querySelector ? container : document;
    root.querySelectorAll('.r3nu-accordion-stack').forEach((stack) => {
      stack.querySelectorAll('.r3nu-accordion--r3nu details').forEach((details, index) => {
        const panel = details.querySelector('.r3nu-accordion-panel');
        if (index === 0) {
          details.setAttribute('open', '');
        } else {
          details.removeAttribute('open');
        }
        if (panel) {
          panel.style.height = '';
          panel.style.overflow = '';
        }
      });
    });
  }

  function initProductAccordions(container) {
    if (prefersReducedMotion()) return;

    const root = container && container.querySelector ? container : document;
    root.querySelectorAll('.product__accordion--r3nu details, .r3nu-accordion--r3nu details').forEach((details) => {
      if (details.dataset.r3nuAccordionBound) return;
      details.dataset.r3nuAccordionBound = 'true';

      const summary = details.querySelector('summary');
      const panel = details.querySelector('.product__accordion-panel, .r3nu-accordion-panel');
      if (!summary || !panel) return;

      summary.addEventListener('click', (event) => {
        const willBeOpen = !details.hasAttribute('open');

        if (willBeOpen) {
          event.preventDefault();
          details.setAttribute('open', '');
          panel.style.overflow = 'hidden';
          panel.style.height = '0px';

          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              const h = panel.scrollHeight;
              if (h === 0) {
                panel.style.height = '';
                panel.style.overflow = '';
                return;
              }
              panel.style.height = `${h}px`;

              let done = false;
              const finish = () => {
                if (done) return;
                done = true;
                clearTimeout(fallbackTimer);
                panel.removeEventListener('transitionend', onTransitionEnd);
                panel.style.height = '';
                panel.style.overflow = '';
              };

              const onTransitionEnd = (e) => {
                if (e.propertyName !== 'height') return;
                finish();
              };

              const fallbackTimer = setTimeout(finish, DURATION_MS + 80);
              panel.addEventListener('transitionend', onTransitionEnd);
            });
          });
          return;
        }

        event.preventDefault();
        panel.style.overflow = 'hidden';
        const startH = panel.scrollHeight;
        panel.style.height = `${startH}px`;

        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            panel.style.height = '0px';
          });
        });

        let done = false;
        const finish = () => {
          if (done) return;
          done = true;
          clearTimeout(fallbackTimer);
          panel.removeEventListener('transitionend', onTransitionEnd);
          details.removeAttribute('open');
          panel.style.height = '';
          panel.style.overflow = '';
        };

        const onTransitionEnd = (e) => {
          if (e.propertyName !== 'height') return;
          finish();
        };

        const fallbackTimer = setTimeout(finish, DURATION_MS + 80);
        panel.addEventListener('transitionend', onTransitionEnd);
      });
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    resetArticleCircuitAccordions(document);
    initProductAccordions(document);
  });
  document.addEventListener('shopify:section:load', (event) => {
    resetArticleCircuitAccordions(event.target);
    initProductAccordions(event.target);
  });
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) {
      resetArticleCircuitAccordions(document);
    }
  });
})();
